import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Scholarshipleft from '../Scholarships/Scholarshipleft'

function AwardeesELe() {
    return (
        <>
         
        <section className="project-detail">
            <Container>
                <Row>

                        <Col md={4} className='c-left custom-padding-color mb-4'>
                           
                            <Scholarshipleft activeIndex={2} />
                    </Col>
                    <Col md={8} className='c-right text-center'>
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                    <h3>Awardees</h3>
                                </div>
                            </div>
                    
                
                        <div id="services" className=" services-area fix col-lg-12 col-md-12">
                            <div className="services-box ">
                                <h3><p>Institute Scholarships for the Academic Year 2022-23  </p></h3>
                                <div className="services-content2">
                                        <Link to="#" className="c-link">Click Here</Link>
                                </div>
                            </div>
                        </div>                
                  </Col>   
                </Row> 
              </Container>
            </section>
        </>
    )
}

export default AwardeesELe;
